/* unplugin-vue-components disabled */import { render } from "./SimpleFormDialog.vue?vue&type=template&id=1c8818b0"
import script from "./SimpleFormDialog.vue?vue&type=script&lang=js"
export * from "./SimpleFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/dagger/dagger/dagger-self/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__